// extracted by mini-css-extract-plugin
export default {"Action":"index_Action_hJb-9","listItem":"index_listItem_gNXHw","text":"index_text_FGJ5K"};